import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Navigate, useNavigate } from 'react-router-dom';
import { auth, kycAPI, wa } from 'services';
import { toast } from 'sonner';
import { images } from 'assets/themes';
import useUniversalStore from 'store/universalStore';

const Signup = () => {
    const navigate = useNavigate();
    const { user, userBasic, write } = useUniversalStore((state) => state);
    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            firstName: "",
            lastName: "",
            email: "",
            businessName: "",
            typeOfBusiness: "trading"
        },
    });

    useEffect(() => {
        if (user && userBasic?.business?.name && userBasic?.business?.type) {
            navigate('/', { replace: true });
        }
    }, [user, userBasic]);

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const { email, businessName, typeOfBusiness } = data;

            const response = await kycAPI.updateUserBasic({
                contact: { email, },
                business: { name: businessName, type: typeOfBusiness }
            });

            const user = auth.fetchUser();

            if (response) {
                toast.success("Profile updated successfully!");
                write({ user: user, userBasic: response });
                wa.sendWelcomeMessage(businessName, user.get("username"));
                navigate('/', { replace: true });
            } else {
                toast.error("Failed to update profile.");
            }

        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
            <div className="col-12 col-sm-10 col-md-7 col-lg-5">
                <div className="card shadow-lg border-0 rounded-4">
                    <div className="card-body p-4 p-md-5">
                        {/* Logo */}
                        <div className="text-center mb-4">
                            <img
                                src={images.logo}
                                alt="logo"
                                style={{ height: 50 }}
                                className="mb-3"
                            />
                            <h4 className="fw-bold mb-1">Personal Details</h4>
                            <p className="text-muted small">
                                Let's get to know you better
                            </p>
                        </div>

                        <form onSubmit={handleSubmit(onSubmit)}>

                            {/* Business Row */}
                            <div className="row">

                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-semibold small">
                                        Business Name
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.businessName ? 'is-invalid' : ''}`}
                                        placeholder="Enter business name"
                                        {...register("businessName", { required: "Business name is required" })}
                                    />

                                    {errors.businessName &&
                                        <div className="invalid-feedback">
                                            {errors.businessName.message}
                                        </div>
                                    }
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-semibold small">
                                        Type of Business
                                    </label>

                                    <select
                                        className={`form-control form-select ${errors.typeOfBusiness ? 'is-invalid' : ''}`}
                                        {...register("typeOfBusiness", { required: "Type of business is required" })}
                                    >
                                        <option value="">Select type</option>
                                        <option value="services">Services</option>
                                        <option value="manufacturing">Manufacturing</option>
                                        <option value="trading">Trading</option>
                                    </select>

                                    {errors.typeOfBusiness &&
                                        <div className="invalid-feedback">
                                            {errors.typeOfBusiness.message}
                                        </div>
                                    }
                                </div>

                            </div>

                            {/* Email */}
                            <div className="mb-4">

                                <label className="form-label fw-semibold small">
                                    Email Address (Optional)
                                </label>

                                <input
                                    type="email"
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    placeholder="name@example.com"
                                    {...register("email", {
                                        pattern: {
                                            value: /^\S+@\S+$/i,
                                            message: "Please enter a valid email"
                                        }
                                    })}
                                />

                                {errors.email &&
                                    <div className="invalid-feedback">
                                        {errors.email.message}
                                    </div>
                                }

                            </div>

                            {/* Button */}
                            <button
                                type="submit"
                                disabled={!isValid || loading}
                                className="btn btn-danger w-100 py-2 fw-semibold"
                            >

                                {loading &&
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                }

                                {loading ? "Saving..." : "Continue"}

                            </button>

                        </form>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default Signup;